import React from "react";
import {
  FaDumbbell,
  FaPaintBrush,
  FaGraduationCap,
  FaMusic,
  FaCamera,
  FaUtensils,
  FaHeart,
  FaTshirt,
} from "react-icons/fa";

const categories = [
  {
    icon: <FaDumbbell className="text-red-500 text-lg" />,
    name: "Fitness & Wellness",
    services: "1,234 Services",
  },
  {
    icon: <FaPaintBrush className="text-blue-400 text-lg" />,
    name: "Art & Crafts",
    services: "867 Services",
  },
  {
    icon: <FaGraduationCap className="text-green-400 text-lg" />,
    name: "Education",
    services: "956 Services",
  },
  {
    icon: <FaMusic className="text-purple-400 text-xlg" />,
    name: "Music & Dance",
    services: "654 Services",
  },
  {
    icon: <FaCamera className="text-yellow-400 text-lg" />,
    name: "Photography",
    services: "432 Services",
  },
  {
    icon: <FaUtensils className="text-orange-400 text-lg" />,
    name: "Food & Cooking",
    services: "789 Services",
  },
  {
    icon: <FaHeart className="text-pink-400 text-lg" />,
    name: "Health & Beauty",
    services: "1,123 Services",
  },
  {
    icon: <FaTshirt className="text-indigo-400 text-lg" />,
    name: "Fashion & Style",
    services: "567 Services",
  },
];

const PopularCategories = () => {
  return (
    // <div className="py-16 px-4 text-center bg-white">
    //   <h2 className="text-2xl md:text-2xl font-bold text-gray-900 mb-2">
    //     Explore Popular Categories
    //   </h2>
    //   <p className="text-gray-600 mb-10">
    //     Discover services and activities across various categories. Find exactly
    //     what you're looking for!
    //   </p>

    //   {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto"> */}
    //   <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
    //     {categories.map((cat, index) => (
    //       <div
    //         key={index}
    //         className="bg-white hover:shadow-sm transition-shadow duration-100 rounded-xl p-5 flex flex-col items-center space-y-2 border border-gray-100"
    //       >
    //         <div className="bg-gray-100 p-4 rounded-full ">{cat.icon}</div>
    //         <h3 className="text-sm font-semibold text-gray-900 ">{cat.name}</h3>
    //         <p className="text-xs text-gray-500">{cat.services}</p>
    //       </div>
    //     ))}
    //   </div>
    // </div>

    <div className="py-5 px-4 text-center bg-white">
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">
        Explore Popular Categories
      </h2>
      <p className="text-xs sm:text-base text-gray-600 mb-10 max-w-xl mx-auto">
        Discover services and activities across various categories. Find exactly
        what you're looking for!
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {categories.map((cat, index) => (
          <div
            key={index}
            className="bg-white hover:shadow-sm transition-shadow duration-100 rounded-xl p-5 flex flex-col items-center space-y-2 border border-gray-100"
          >
            <div className="bg-gray-100 p-4 rounded-full">{cat.icon}</div>
            <h3 className="text-xs sm:text-sm font-semibold text-gray-900">
              {cat.name}
            </h3>
            <p className="text-[10px] sm:text-xs text-gray-500">
              {cat.services}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularCategories;
